import { FONT, MEDIA, RADIUS } from "@/styles/common";
import { Box, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { RoomDetailProps } from "./roomDetail.type";

export const RoomDetail = ({ roomDetailInfo, date, addPeople, imgUrl, handleDeleteRoom }: RoomDetailProps) => {
    const { name, personOfCapacity } = roomDetailInfo;
    const { isMobile } = MEDIA();

    return (
        <Flex flexDir="column" justifyContent="space-between" gap={"16px"}>
            <Flex flexDir={isMobile ? "column" : "row"} gap="16px">
                <Box
                    background={`url(${imgUrl})no-repeat center/cover`}
                    w={isMobile ? "100%" : "160px"}
                    h={isMobile ? "200px" : "118px"}
                    borderRadius="8px"
                />
                <Flex flex="1" position="relative">
                    <Flex flex="1" flexDir="column" justifyContent="space-between" rowGap={isMobile ? "8px" : "auto"}>
                        <Box>
                            <Text fontSize={isMobile ? "16px" : "20px"}>{name}</Text>
                            <CustomBasicText fontSize={isMobile ? "14px" : "16px"}>
                                기준 : {personOfCapacity.min}명 / 최대 : {personOfCapacity.max}명
                            </CustomBasicText>
                        </Box>
                        <Flex flexDir="column">
                            <CustomBasicText fontSize={isMobile ? "14px" : "16px"}>
                                투숙 인원 : 성인 {Number(personOfCapacity.min) + Number(addPeople.adult)}명 / 아동{" "}
                                {addPeople.child}명 / 유아 {addPeople.infant}명
                            </CustomBasicText>
                            <CustomBasicText>체크인/아웃 : {date}</CustomBasicText>
                        </Flex>
                    </Flex>
                    <CustomDeleteHandlerText
                        position="absolute"
                        top="0"
                        right="0"
                        flexWrap="nowrap"
                        justifyContent="flex-end"
                        alignItems="center"
                        boxSizing="border-box"
                        p="4px 8px"
                        h="24px"
                        onClick={handleDeleteRoom}
                        cursor="pointer"
                        columnGap="4px"
                    >
                        <Text fontFamily="Pretendard Variable" fontSize={isMobile ? "12px" : "14px"}>
                            삭제
                        </Text>
                        <Text as="span" fontSize={isMobile ? "14px" : "20px"} className="material-icons">
                            close
                        </Text>
                    </CustomDeleteHandlerText>
                </Flex>
            </Flex>
        </Flex>
    );
};

const CustomBasicText = styled(Text)`
    color: ${({ theme }) => theme.COLOR.gray[500]};
    ${FONT("pretendard", 16, 300)};
    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        font-size: 14px !important;
    }
`;

const CustomDeleteHandlerText = styled(Flex)`
    color: ${({ theme }) => theme.COLOR.white};
    background: ${({ theme }) => theme.COLOR.gray[200]};
    ${RADIUS(2)}

    &:hover {
        background: ${({ theme }) => theme.COLOR.gray[300]};
    }
`;
